import { BaseLayout } from './Containers/BaseLayout';
import { Footer } from './components/Footer/Footer';
import './App.css';


function App() {
  return (
    <div className="App">
      <BaseLayout/>
      <Footer/>
    </div>
  );
}

export default App;
